// @flow

import React from 'react'

type Resource = {
  name: string,
  url: string,
  chapter: {
    title: string
  }
};

export default ({ resources, bookTitle }: { resources: Resource[], bookTitle: string }) => <div>
  <h1 id="resources">Resources</h1>
  {resources.map((r, i) => <div key={i}>
    <a href={r.url} target="_blank"><h4>{r.name}</h4></a>
    <p><em>From the {r.chapter.title} chapter of {bookTitle}</em></p>
  </div>)}
</div>


// WEBPACK FOOTER //
// ./src/components/Resources.js